import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";

export default function Loader() {
  const [visible, setVisible] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion) {
      const t = setTimeout(() => setVisible(false), 850);
      return () => clearTimeout(t);
    }

    const tween = gsap.to(containerRef.current, {
      opacity: 0,
      duration: 0.5,
      delay: 0.85,
      ease: "power2.inOut",
      onComplete: () => setVisible(false),
    });

    return () => {
      tween.kill();
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      ref={containerRef}
      data-testid="page-loader"
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{ background: "var(--body-bg)" }}
    >
      <div className="absolute inset-0 aurora" />
      <div className="relative flex flex-col items-center gap-6">
        <div className="dot-loader" />
        <div className="text-sm font-mono tracking-[0.3em] text-[var(--body-fg)]/60">
          DIBRAL
        </div>
      </div>
    </div>
  );
}
